/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the options for how columns animate while resizing.
 */
export var ColumnResizingAnimationMode = /*@__PURE__*/ (function (ColumnResizingAnimationMode) {
    /**
     * Automatically decides on the animation mode to use.
     */
    ColumnResizingAnimationMode[ColumnResizingAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    ColumnResizingAnimationMode[ColumnResizingAnimationMode["None"] = 1] = "None";
    /**
     * The column width interpolates to the new width.
     */
    ColumnResizingAnimationMode[ColumnResizingAnimationMode["Interpolate"] = 2] = "Interpolate";
    return ColumnResizingAnimationMode;
})({});
/**
 * @hidden
 */
export var ColumnResizingAnimationMode_$type = /*@__PURE__*/ markEnum('ColumnResizingAnimationMode', 'Auto,0|None,1|Interpolate,2');
//# sourceMappingURL=ColumnResizingAnimationMode.js.map
